import * as jsonpointer from 'jsonpointer';
import { cleanRef } from './clean-ref.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getContentByRef(ref, pageModel, refPrefix) {
    if (!ref || !pageModel) {
        return undefined;
    }
    const parsedRef = cleanRef(ref, refPrefix);
    return jsonpointer.get(pageModel, parsedRef);
}

export { getContentByRef };
//# sourceMappingURL=get-content-by-ref.js.map
